import { createFileRoute } from "@tanstack/react-router";
import { ContractComparisonPage } from "@/features/contracts/contract-comparison-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/porownanie/$id")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.porownanie",
			location.pathname,
		);
	},
	component: ContractComparisonPage,
});
